import React from 'react';
import { Person20Regular, Shield20Regular, Mail20Regular } from '@fluentui/react-icons';
import { USER_SETTINGS_SECTIONS } from './userSettingsConstants';
import styles from './css/UserSettings.module.css';

const NAV_ITEMS = [
    { id: USER_SETTINGS_SECTIONS.PROFILE, label: 'Profile', Icon: Person20Regular },
    { id: USER_SETTINGS_SECTIONS.SECURITY, label: 'Security & Sign-in', Icon: Shield20Regular },
    { id: USER_SETTINGS_SECTIONS.EMAIL, label: 'Email Preferences', Icon: Mail20Regular },
];

const SettingsNav = ({ selected, onSelect }) => (
    <nav className={styles.settingsNav} aria-label="User settings">
        <ul className={styles.settingsNavList}>
            {NAV_ITEMS.map(({ id, label, Icon }) => {
                const isActive = selected === id;
                return (
                    <li key={id}>
                        <button
                            type="button"
                            className={isActive ? `${styles.settingsNavItem} ${styles.settingsNavItemActive}` : styles.settingsNavItem}
                            onClick={() => onSelect(id)}
                            aria-current={isActive ? 'page' : undefined}>
                            <Icon className={styles.settingsNavIcon} aria-hidden />
                            {label}
                        </button>
                    </li>
                );
            })}
        </ul>
    </nav>
);

export default SettingsNav;
